import { useRef } from "react";

export const useAbortControllers = () => {
    const controllers = useRef<AbortController[]>([]);

    const abortAll = () => {
        controllers.current.forEach((controller) => controller.abort());
    }

    const controlledCall = async <T>(fn: (newController: AbortController) => Promise<T>): Promise<T> => {
        const newAbortController = new AbortController();
        controllers.current.push(newAbortController);
        const response: T = await fn(newAbortController);
        controllers.current = controllers.current.filter((controller) => controller !== newAbortController);
        return response;
    }

    return { controllers, abortAll, controlledCall }
}
